import type { EquipmentInfoId, ExerciseInfo, MovementInfoId } from '@az3fr/core';
import { createID } from '@az3fr/core';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

// Factory Function (The blueprint for a new exercise)
function createNewUserExercise(args: {
	movementId: MovementInfoId;
	equipmentId: EquipmentInfoId;
}): ExerciseInfo {
	const { movementId, equipmentId } = args;
	const now = new Date().toISOString();
	return {
		id: createID('exercise'),
		movementId,
		equipmentId,
		// @todo: hardcoded for now
		equipmentCount: 1,
		updatedAt: now,
	};
}

const exerciseAdapter = createEntityAdapter<ExerciseInfo>();

const exerciseSlice = createSlice({
	name: 'entities/exercise',
	initialState: exerciseAdapter.getInitialState(),
	reducers: {
		setAll: exerciseAdapter.setAll,

		addedOne: exerciseAdapter.addOne,
		addedMany: exerciseAdapter.addMany,

		updatedOne: exerciseAdapter.updateOne,
		updatedMany: exerciseAdapter.updateMany,

		removedOne: exerciseAdapter.removeOne,
		removedMany: exerciseAdapter.removeMany,
	},
});
type ExerciseSliceState = ReturnType<typeof exerciseAdapter.getInitialState>;

const exerciseSliceActions = { ...exerciseSlice.actions };
const exerciseSliceReducer = exerciseSlice.reducer;

export { exerciseAdapter, createNewUserExercise, exerciseSliceActions, exerciseSliceReducer };
export type { ExerciseSliceState };
